<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px">
        <el-form-item label="结算规则信息" prop="settlementId">
          <div class="style">
            <el-select v-model="ruleForm.settlementId" placeholder="" @change="changeSpecial">
              <el-option
                v-for="item in subjectTypeList"
                :key="item.settlementRulesId"
                :label="`${item.applicableIndustry}----${item.settlementRules}`"
                :value="item.settlementRulesId"
              >
              </el-option>
            </el-select>
          </div>
          <p class="labels-tips">请根据实际经营行业选择结算规则。</p>
        </el-form-item>
        <el-form-item label="特殊资质" prop="qualifications">
          <div class="style">
            <el-select v-model="ruleForm.qualifications" placeholder="" @change="change">
              <el-option
                v-for="(item, index) in specialList"
                :key="index"
                :label="item.qualifications"
                :value="`${item.qualifications},${item.qualificationsCopy}`"
              >
              </el-option>
            </el-select>
          </div>
          <p class="labels-tips">请提供未“申请商家主体”所属的特殊资质，可授权使用总公司/分公司的特殊资质。</p>
        </el-form-item>
        <el-form-item
          v-if="type && qualificationsType && !isUpload"
          class="style"
          label="特殊资质图片"
          prop="qualificationsCopy"
        >
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.qualificationsCopy && ruleForm.qualificationsCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :action="$configUrl.uploadUrl"
                :file-list="imgList"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return uboInfoIdCardCopySuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="!type && qualificationsType && !isUpload" class="style" label="特殊资质图片">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.qualificationsCopy && ruleForm.qualificationsCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return uboInfoIdCardCopySuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="优惠费率活动">
          <div class="style">
            <el-select v-model="ruleForm.activitiesId" placeholder="">
              <el-option v-for="item in specialList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <p class="labels-tips">部分结算规则和特殊资质，可报名优惠费率活动</p>
        </el-form-item> -->
        <!-- <el-form-item label="优惠费率活动值">
          <el-input v-model="ruleForm.activitiesRate" placeholder="" clearable>
            <template slot="append">%</template>
          </el-input>
        </el-form-item> -->
        <!-- <el-form-item class="style" label="优惠费率活动补充材料">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.activitiesAdditions.length > 2 ? 'hide' : ''"
                list-type="picture-card"
                :action="$configUrl.uploadUrl"
                :on-success="
                  (response, file, fileList) => {
                    return activitiesAdditionsSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="style"></div>
              <p class="labels-tips">请上传优惠费率活动补充材料</p>
              <div class="style"></div>
            </div>
          </div>
        </el-form-item> -->
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    subjectTypeList: {
      type: Array,
      default: () => [],
    },
    specialList: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number || Boolean,
      default: false,
    },
    ruleData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      qualificationType: '',
      isUpload: false,
      isUploadType: false,
      imgList: [],
      ruleForm: {
        settlementId: '',
        qualifications: '',
        qualificationsCopy: [],
        activitiesId: '',
        activitiesRate: '',
        activitiesAdditions: '',
        specialType: '',
      },
      type: false,
      qualificationsType: false,
      rules: {
        settlementId: [{ required: true, message: '请选择结算规则', trigger: ['blur', 'change'] }],
        qualifications: [{ required: true, message: '请选择特殊资质', trigger: ['blur', 'change'] }],
        qualificationsCopy: [{ required: true, message: '请上传特殊资质图片', trigger: ['blur', 'change'] }],
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  created() {
    console.log(this.id);
  },
  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    ruleData: {
      handler: function (data) {
        if (data.settlementRulesVO) {
          console.log(data);
          this.ruleForm = data.settlementRulesVO;
          let qualificationsCopyList = data.settlementRulesVO.qualificationsCopy.split(',');
          this.ruleForm.qualifications = `${data.settlementRulesVO.qualifications},${data.settlementRulesVO.qualificationType}`;
          if (data.settlementRulesVO.qualificationsCopy != '') {
            this.isUpload = true;
          } else {
            this.isUploadType = true;
          }
          // if (data.settlementRulesVO.qualificationType == '是') {
          //   this.isUpload = true;
          // } else if (data.settlementRulesVO.qualificationType == '否') {
          //   this.isUpload = false;
          // } else {
          //   this.isUpload = false;
          // }
          this.imgList = qualificationsCopyList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
    },
  },

  methods: {
    uboInfoIdCardCopySuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.qualificationsCopy = file.response.data.url;
      console.log(this.ruleForm.qualificationsCopy);
      this.$emit('handleMediaId', this.ruleForm.qualificationsCopy,file.name);
    },
    activitiesAdditionsSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.activitiesAdditions = file.response.data.url;
      console.log(this.ruleForm.activitiesAdditions);
    },
    changeSpecial(val) {
      console.log(val);
      this.$emit('changeSpecial', val);
    },
    change(val) {
      console.log(val);
      let changeList = [];
      changeList = val.split(',');
      console.log(changeList);
      if (changeList[1] == '是') {
        this.type = true;
        this.qualificationsType = true;
        console.log(this.type);
      } else if (changeList[1] == '否') {
        this.qualificationsType = false;
        console.log(this.type);
      } else {
        this.type = false;
        this.qualificationsType = true;
      }
    },
    handleRemove() {
      this.ruleForm.qualificationsCopy = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
